export default {
  APPLE_STORE: 'AppleStore',
  CREATE_WALLET: 'CreateWallet',
  ACCESS_WALLET: 'AccessWallet',
  GOOGLE_STORE_2: 'GoogleStore2',
  APPLE_STORE_2: 'AppleStore2',
  GOOGLE_STORE_3: 'GoogleStore3',
  CREATE_WALLET_2: 'CreateWallet2',
  ACCESS_WALLET_2: 'AccessWallet2',
  MEWTOPIA: 'MewTopia',
  PARTNERS: 'Partners',
  ENKRYPT_LEARN_MORE: 'EnkryptLearnMore',
  ACCESS_WALLET_MINT: 'AccessWalletMint',
  SWAP_CLICKED: 'SwapClicked',
  GET_TOKENS_CLICKED: 'GetTokensClicked',
  MEW_COMMUNITY: 'MEWCommunity',
  ACCESS_WALLET_MOBILE: 'AccessWalletMobile',
  CREATE_WALLET_MOBILE: 'CreateWalletMobile'
};
